import { z } from 'zod';

export const columnsWidthStateValidator = z.record(
  z.string(),
  z.number().or(z.undefined()),
);
